var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<li class=\"item\">\n    <a title=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "\" class=\"product-image\"><img src=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"image_thumbnail") : depth0), depth0))
    + "\" width=\"75\" height=\"75\"\n            alt=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "\"></a>\n    <div class=\"product-details\">\n        <p class=\"product-name\">"
    + alias2(__default(require("../helpers/trimString.js")).call(alias3,(depth0 != null ? lookupProperty(depth0,"name") : depth0),0,60,{"name":"trimString","hash":{},"data":data,"loc":{"start":{"line":6,"column":32},"end":{"line":6,"column":58}}}))
    + "</p>\n        Qty: <strong>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"qty") : depth0), depth0))
    + "</strong><br>\n        <div class=\"product-price\">\n            <span class=\"price\">"
    + alias2(__default(require("../helpers/currency.js")).call(alias3,(depth0 != null ? lookupProperty(depth0,"price") : depth0),{"name":"currency","hash":{},"data":data,"loc":{"start":{"line":9,"column":32},"end":{"line":9,"column":51}}}))
    + "</span>\n        </div>\n    </div>\n</li>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"items") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":13,"column":9}}})) != null ? stack1 : "");
},"useData":true});